export const getReturnPath = (state: unknown, fallback: string): string => {
  const returnTo = (state as { returnTo?: unknown } | null)?.returnTo;
  if (typeof returnTo !== "string") return fallback;
  const isAllowed =
    returnTo === fallback || returnTo.startsWith(`${fallback}?`);
  return isAllowed ? returnTo : fallback;
};
